<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Details</label>
  <span class="spacer"></span>
  @if (canExpand) {
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  }
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <span>
        <label class="informationLabel">Selected Unit Count:</label>
        <label class="informationValue">{{ displayUnitCount }}</label>
        <label class="informationLabel">Tags:</label>
        <label class="informationValue">{{ displayTags() }}</label>
        <button class="taggingButton primary-button" matButton="elevated" (click)="openTagsDialog()">
          <span>
            <mat-icon class="size-12">local_offer</mat-icon>
            <label class="buttonLabel">Manage Tags</label>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
      <span>
        @if (packagingSelection) {
          <span class="selectionContainer">
            <label class="selectionLabel">Packaging:</label>
            <select #packagingInput [class.invalidConfigurationSelection]="isInvalidSelection(packagingSelection.Name)"
              (change)="selectedValueChanged(packagingSelection.Name, packagingInput.value)"
              [value]="packagingSelection.Value.toString()">
              @for (allowable of packagingSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="packagingSelection.Value && packagingSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
  </div>
}
